import { Roles } from "../../constants/roles";
import { FormBase } from "../form-base-form";

type DropdownMenuType = "post" | "comment";

class DropdownForm extends FormBase {
    public getSearchContext(isInModal: boolean): ParentNode {
        return (
            (isInModal
                ? this.queryElement(document, `[data-role="${Roles.ELEMENT_MODAL_BODY}"]`, HTMLElement)
                : null) || document
        );
    }

    public getDropdownControls(root: ParentNode = document): HTMLButtonElement[] {
        return this.queryElements(
            root,
            [
                `[data-role="${Roles.POST_MENU_BUTTON}"]`,
                `[data-role="${Roles.COMMENT_MENU_BUTTON}"]`,
                `[data-role="${Roles.POST_MENU}"] [data-dropdown-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
                `[data-role="${Roles.POST_MENU}"] [data-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-dropdown-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-role="${Roles.COMMENT_ACTION_EDIT}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-role="${Roles.COMMENT_ACTION_DELETE}"]`,
            ].join(", "),
            HTMLButtonElement,
        );
    }

    public getEventTarget(event: Event): Element | null {
        return this.fromEventTarget(event, Element);
    }

    public getMenuButton(target: Element | null | undefined, type: DropdownMenuType): HTMLButtonElement | null {
        const selector =
            type === "post" ? `[data-role="${Roles.POST_MENU_BUTTON}"]` : `[data-role="${Roles.COMMENT_MENU_BUTTON}"]`;
        return this.closest(target, selector, HTMLButtonElement);
    }

    public getModalBody(target: Element | null | undefined): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.ELEMENT_MODAL_BODY}"]`, HTMLElement);
    }

    public getMenuById(root: ParentNode, type: DropdownMenuType, itemId: number): HTMLElement | null {
        return this.queryElement(root, `#${type}-menu-${itemId}`, HTMLElement);
    }

    public getButtonById(root: ParentNode, type: DropdownMenuType, itemId: number): HTMLElement | null {
        const buttonRole = type === "post" ? Roles.POST_MENU_BUTTON : Roles.COMMENT_MENU_BUTTON;
        return this.queryElement(root, `[data-role="${buttonRole}"][data-${type}-id="${itemId}"]`, HTMLElement);
    }

    public getAllMenus(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.POST_MENU}"], [data-role="${Roles.COMMENT_MENU}"]`,
            HTMLElement,
        );
    }

    public getVisibleMenus(root: ParentNode = document): HTMLElement[] {
        return this.getAllMenus(root).filter((menu) => menu.style.display === "block");
    }

    public getPostDropdownContainers(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.POST_DROPDOWN_CONTAINER}"]`, HTMLElement);
    }

    public getCommentDropdownContainers(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.COMMENT_DROPDOWN_CONTAINER}"]`, HTMLElement);
    }

    public getPostMenu(target: Element | null | undefined): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.POST_MENU}"]`, HTMLElement);
    }

    public getCommentMenu(target: Element | null | undefined): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.COMMENT_MENU}"]`, HTMLElement);
    }

    public getPostMenuItem(target: Element | null | undefined): HTMLElement | null {
        return this.closest(
            target,
            `[data-role="${Roles.POST_MENU}"] [data-dropdown-role="${Roles.DROPDOWN_MENU_ITEM}"], [data-role="${Roles.POST_MENU}"] [data-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
            HTMLElement,
        );
    }

    public getCommentMenuItem(target: Element | null | undefined): HTMLElement | null {
        return this.closest(
            target,
            [
                `[data-role="${Roles.COMMENT_MENU}"] [data-dropdown-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-role="${Roles.DROPDOWN_MENU_ITEM}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-role="${Roles.COMMENT_ACTION_EDIT}"]`,
                `[data-role="${Roles.COMMENT_MENU}"] [data-role="${Roles.COMMENT_ACTION_DELETE}"]`,
            ].join(", "),
            HTMLElement,
        );
    }
}

const dropdownForm = new DropdownForm();

export { DropdownForm, dropdownForm };
